import { TuneIcon } from './TuneIcon';

/**
 * author: Google
 * id B1F7C2ED-4017-4162-A4C7-31D8761D8DC3
 * name tune
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tune.svg
 * tags
 * - Settings 
 * - Audio 
 */
export const EqualiserIcon = TuneIcon;
export default EqualiserIcon